import { useQuery } from "@tanstack/react-query";
import { getBusinessActivitiesByLanguage } from "../apis/businessActivities";

export const useBusinessActivitiesQuery = (languageCode) =>
    useQuery({
        queryKey: ["business-activities", languageCode],
        queryFn: () => getBusinessActivitiesByLanguage(languageCode),
        enabled: Boolean(languageCode),
    });
